G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.SpecialType = function(config) {
  this.signals = {
    removeCandy: new Phaser.Signal(),
    changeCandyTexture: new Phaser.Signal(),
  };
  this.candy = null;
  this.config = null;
};

G.BoardCandy.SpecialType.prototype = {
  init: function(candy, config) {
    this.candy = candy;
    this.config = config;

    if (config.texture) {
      var spriteName = config.texture.replace(
        "%CANDYTYPE%", this.candy.getBaseTypeSymbol());
      this.signals.changeCandyTexture.dispatch(spriteName);
    }

    if (config.candyType) {
      if (config.candyType === "RANDOM") {
        this.reportedCandyType = Math.random();
      } else {
        this.reportedCandyType = config.candyType;
      }
    }

    if (config.collectBaseType && !this.candy.baseType.isAlreadyCollected()) {
      G.sb("onCollectableRemove").dispatch(this.candy.getBaseTypeSymbol(), false);
      this.candy.baseType.markAsCollected();
    }

    this.tags = G.Utils.defined(config.tags, []);

    if (config.onMatchFx) this.onMatchFx = G.Utils.clone(config.onMatchFx);
    this.specialType = G.Utils.defined(config.specialType, null);

    this.activatedByMove = G.Utils.defined(config.activatedByMove, false);

    if (config.exe) this.exe = G.Utils.clone(config.exe);
  },

  isBlockingMove: function() {
    return false;
  },

  isMatchable: function() {
    return true;
  },

  onMove: function() {
    return true;
  },

  onHit: function() {
    return true;
  },

  startMatchFx: function() {
    if (this.onMatchFx) {
      this.onMatchFx.forEach(function(child) {
        G.sb("fx").dispatch(child[0],this.candy,child[1],this.candy);
      },this);
    }
  },

  getExe: function() {
    return this.exe;
  },

  getSpecialType: function() {
    return this.specialType;
  },

  isActivatedByMove: function() {
    return this.activatedByMove;
  },

  onMatch: function() {
    return true;
  },

  changeMatchToken: function(token) {
    return this.reportedCandyType || token;
  },

  getEditorSymbol: function() {
    return this.editorSymbol;
  },

  export: function() {
    return this.config.editorSymbol;
  },

  passMatchable: function(matchable) {
    return matchable;
  },

  hasTag: function(tag) {
    return this.tags.indexOf(tag) !== -1;
  },
};